import { render, staticRenderFns } from "./NewFile.vue?vue&type=template&id=4b2154e1"
import script from "./NewFile.vue?vue&type=script&lang=js"
export * from "./NewFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports